export default __webpack_public_path__ + "static/media/loading.6312bd6e.svg";